import { useTranslation } from "react-i18next";
import { useAdvancedSearch } from "@/context/advanced-search/AdvancedSearchContext";
import { getSortFieldTranslationKey } from "@/config/forms/advanced-search/artist-sort-fields";
import { FilterStatus } from "@/components/StatusTableTab";

type FilterItemProps = {
  label: string;
};

export const FilterItem = ({ label }: FilterItemProps) => {
  return (
    <div className="px-2 py-0.5 bg-brand-50 rounded-xl border border-brand-200">
      <span className="text-sm text-brand-700">{label}</span>
    </div>
  );
};

type ExportFiltersProps = {
  filterStatus: FilterStatus;
};

export const ExportFilters = ({ filterStatus }: ExportFiltersProps) => {
  const { t } = useTranslation();
  const advancedSearch = useAdvancedSearch();

  return (
    <div className="flex gap-2">
      {advancedSearch.advancedSearchQuery && (
        <FilterItem
          label={
            advancedSearch.advancedSearchQuery.name
              ? advancedSearch.advancedSearchQuery.name
              : t("advancedSearchWithoutName")
          }
        />
      )}
      {advancedSearch.globalSearch && (
        <FilterItem
          label={t("search") + ' : "' + advancedSearch.globalSearch + '"'}
        />
      )}
      {filterStatus && filterStatus !== "all" && (
        <FilterItem label={t(filterStatus)} />
      )}
      {advancedSearch.sortFields && (
        <FilterItem
          label={
            t("dashBoardSortResults") +
            " : " +
            advancedSearch.sortFields
              .map((field) => t(getSortFieldTranslationKey(field.key)))
              .join(", ")
          }
        />
      )}
    </div>
  );
};
